import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import Button from '../components/Button';
import CallOut from '../components/CallOut';
import { PlanTier, UserType } from '../graphql/generated/graphql';
import UserListHoverCard from '../user/UserListHoverCard';
import { useAllAdmins } from '../user/useAllUsers';

interface InvitationSeatCalloutProps {
  guestLimitReached: boolean;
}

const InvitationSeatCallout = ({
  guestLimitReached,
}: InvitationSeatCalloutProps) => {
  const admins = useAllAdmins();
  const isAdmin = useAppSelector(
    (state) => state.session.user.type === UserType.Admin,
  );
  const planTier = useAppSelector(
    (state) => state.session.organization.planTier,
  );

  if (planTier === PlanTier.Free) {
    if (isAdmin) {
      return (
        <CallOut variant="danger">
          Your team has reached the seat limit for our free plan. Please upgrade
          to a paid plan to add additional teammates.
        </CallOut>
      );
    }
    return (
      <CallOut variant="danger">
        Your team has reached the seat limit for our free plan. Please{' '}
        <UserListHoverCard users={admins}>
          <Button variant="link">contact an admin</Button>
        </UserListHoverCard>{' '}
        to add additional teammates.
      </CallOut>
    );
  }

  if (guestLimitReached) {
    if (isAdmin) {
      return (
        <CallOut variant="danger">
          Your team has reached the seat limit for your plan. Please{' '}
          <a href="mailto:support@slab.com">contact support</a> to add
          additional teammates.
        </CallOut>
      );
    }
    return (
      <CallOut variant="danger">
        Your team has reached the seat limit for your plan. Please{' '}
        <UserListHoverCard users={admins}>
          <Button variant="link">contact an admin</Button>
        </UserListHoverCard>{' '}
        to add additional teammates.
      </CallOut>
    );
  }
  if (isAdmin) {
    return (
      <CallOut variant="warning">
        Your team has reached the seat limit for your plan. You can still invite
        guests, but please <a href="mailto:support@slab.com">contact support</a>{' '}
        to add additional teammates.
      </CallOut>
    );
  }
  return (
    <CallOut variant="warning">
      Your team has reached the seat limit for your plan. You can still invite
      guests, but please{' '}
      <UserListHoverCard users={admins}>
        <Button variant="link">contact an admin</Button>
      </UserListHoverCard>{' '}
      to add additional teammates.
    </CallOut>
  );
};

export default InvitationSeatCallout;
